// Angular
import { Component, OnInit, Input } from '@angular/core';
// RxJS
import { Observable } from 'rxjs';
// NGRX
import { select, Store } from '@ngrx/store';
// State
import { AppState } from '../../../../../core/reducers';
import { currentUser, Logout, User } from '../../../../../core/auth';
import { SafeResourceUrl, DomSanitizer } from '@angular/platform-browser';
import { DialogService } from '../../../../../services/dialog-service.service';
import { ModifUserDialog } from '../../dialog/modif-user-dialog/modif-user-dialog.component';
import { AuthService } from '../../../../../core/auth/_services/auth.service'
import { StateService } from '../../../../../services/state.service';
@Component({
	selector: 'kt-user-profile',
	templateUrl: './user-profile.component.html',
})
export class UserProfileComponent implements OnInit {
	// Public properties
	user$: Observable<User>;

    user: any;
    userDroits: any;

	@Input() showAvatar: boolean = true;
	@Input() showHi: boolean = true;
	@Input() showBadge: boolean = false;

	/**
	 * Component constructor
	 *
	 * @param store: Store<AppState>
	 */
	constructor(
		private store: Store<AppState>,
		private _sanitizer: DomSanitizer,
        private dialogService: DialogService,
        private authService: AuthService,
        private stateService : StateService,
        ) {
	}

	/**
	 * @ Lifecycle sequences => https://angular.io/guide/lifecycle-hooks
	 */

	/**
	 * On init
	 */
	ngOnInit(): void {
		this.user$ = this.store.pipe(select(currentUser));
        this.stateService.user.subscribe((user) => {
            this.user = user;
        })
	}

	bypassSecurity(src: string): SafeResourceUrl {
		return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpg;base64,'+src)
	}
	/**
	 * Log out
	 */
	logout() {
		this.store.dispatch(new Logout());
	}

    modifUser(){
        this.dialogService.open(ModifUserDialog, {
            panelClass: 'pos-relative-dialog',
            data: {
                user:this.user
            },
            height: "80vh",
            width: "80vw",
            draggable: true,
            resizable: true,
            minimizable: true,
            maximizable: true,
        })
    }
	
	getTypeList() {
				let types:string[]=[];
				if (this.user!=undefined && this.user.type!=undefined)
					types.push(this.user.type);
				return types;
	}
}
